/**
 * Maps quoter/transaction charge-type keys to user-facing labels.
 * Lives in shared/common because both shared utilities and business modules
 * (transaction, exchange, dashboard) consume it.
 */
export function textFeeQuoter(key: string): string {
  const names: { [key: string]: string } = {
    'IMPUESTO FINANCIERO': 'Impuesto financiero',
    'IMPUESTO IVA': 'Impuesto IVA',
    GMF: 'Estimado de impuesto · GMF (4x1.000)',
    'SIN COSTO': 'Sin costo',
    'COSTO OPERACIONAL': 'Cargo por servicio',
  };

  return names[key] ? names[key] : key;
}
